(function() {
  var strip = document.getElementById('cp-gallery-strip');
  if (!strip) return;
  var previewArea = document.querySelector('.custom-print-preview');
  var gallery = document.getElementById('cp-gallery');
  if (!previewArea || !gallery) return;

  // Add class so CSS can adjust padding
  previewArea.classList.add('has-gallery');

  // Create full-size viewer wrapper + image BEFORE gallery
  var galleryWrap = document.createElement('div');
  galleryWrap.className = 'cp-gallery-full-wrap';
  var galleryImg = document.createElement('img');
  galleryImg.className = 'cp-gallery-full';
  galleryImg.alt = 'Product photo';
  galleryWrap.appendChild(galleryImg);

  // Video element (hidden by default)
  var galleryVideo = document.createElement('video');
  galleryVideo.className = 'cp-gallery-full cp-gallery-full--video';
  galleryVideo.controls = true;
  galleryVideo.playsInline = true;
  galleryVideo.style.display = 'none';
  galleryWrap.appendChild(galleryVideo);

  // Iframe for external videos (hidden by default)
  var galleryIframe = document.createElement('iframe');
  galleryIframe.className = 'cp-gallery-full cp-gallery-full--iframe';
  galleryIframe.setAttribute('allowfullscreen', '');
  galleryIframe.setAttribute('allow', 'autoplay; encrypted-media');
  galleryIframe.frameBorder = '0';
  galleryIframe.style.display = 'none';
  galleryWrap.appendChild(galleryIframe);

  // Arrow buttons
  var prevBtn = document.createElement('button');
  prevBtn.className = 'cp-gallery-arrow cp-gallery-arrow--prev';
  prevBtn.type = 'button';
  prevBtn.innerHTML = '\u2039';
  prevBtn.title = 'Previous';
  galleryWrap.appendChild(prevBtn);

  var nextBtn = document.createElement('button');
  nextBtn.className = 'cp-gallery-arrow cp-gallery-arrow--next';
  nextBtn.type = 'button';
  nextBtn.innerHTML = '\u203A';
  nextBtn.title = 'Next';
  galleryWrap.appendChild(nextBtn);

  // Insert wrap before gallery in DOM
  gallery.parentNode.insertBefore(galleryWrap, gallery);

  // X close button
  var closeBtn = document.createElement('button');
  closeBtn.className = 'cp-gallery-close';
  closeBtn.type = 'button';
  closeBtn.innerHTML = '\u2715';
  closeBtn.title = 'Close gallery';
  galleryWrap.appendChild(closeBtn);

  // Back button — placed in the full-wrap viewer, not the thumbnail strip
  var backBtn = document.createElement('button');
  backBtn.className = 'cp-gallery-back';
  backBtn.type = 'button';
  backBtn.innerHTML = '\u2190 Back to Customise';
  galleryWrap.appendChild(backBtn);

  var thumbs = strip.querySelectorAll('.cp-gallery-thumb');

  // Preload full-res images
  thumbs.forEach(function(t) {
    if (t.dataset.galleryType === 'image') {
      var img = new Image(); img.src = t.dataset.gallerySrc;
    }
  });

  var currentIndex = -1;

  function hideAllMedia() {
    galleryImg.style.display = 'none';
    galleryVideo.style.display = 'none';
    galleryVideo.pause();
    galleryVideo.innerHTML = '';
    galleryIframe.style.display = 'none';
    galleryIframe.src = '';
  }

  function showMedia(thumb) {
    hideAllMedia();
    var type = thumb.dataset.galleryType;

    if (type === 'image') {
      galleryImg.src = thumb.dataset.gallerySrc;
      galleryImg.style.display = '';
    } else if (type === 'video') {
      try {
        var sources = JSON.parse(thumb.dataset.galleryVideoSources);
        sources.forEach(function(s) {
          var source = document.createElement('source');
          source.src = s.url;
          source.type = s.mime;
          galleryVideo.appendChild(source);
        });
      } catch(e) {}
      galleryVideo.style.display = '';
      galleryVideo.load();
    } else if (type === 'external_video') {
      galleryIframe.src = thumb.dataset.galleryEmbedUrl;
      galleryIframe.style.display = '';
    }
  }

  function goTo(index) {
    currentIndex = ((index % thumbs.length) + thumbs.length) % thumbs.length;
    showMedia(thumbs[currentIndex]);
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    thumbs[currentIndex].classList.add('active');
    thumbs[currentIndex].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  function openGallery(index) {
    previewArea.classList.add('cp-gallery-viewing');
    goTo(index);
  }

  function closeGallery() {
    hideAllMedia();
    previewArea.classList.remove('cp-gallery-viewing');
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    currentIndex = -1;
  }

  // Arrow clicks
  prevBtn.addEventListener('click', function() { if (currentIndex >= 0) goTo(currentIndex - 1); });
  nextBtn.addEventListener('click', function() { if (currentIndex >= 0) goTo(currentIndex + 1); });

  // Thumbnail click
  strip.addEventListener('click', function(e) {
    var thumb = e.target.closest('.cp-gallery-thumb');
    if (!thumb) return;
    var idx = Array.prototype.indexOf.call(thumbs, thumb);
    openGallery(idx);
  });

  // Back button (desktop)
  if (backBtn) backBtn.addEventListener('click', closeGallery);

  // X close button
  closeBtn.addEventListener('click', closeGallery);

  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (currentIndex < 0) return;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { goTo(currentIndex - 1); e.preventDefault(); }
    else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { goTo(currentIndex + 1); e.preventDefault(); }
    else if (e.key === 'Escape') { closeGallery(); e.preventDefault(); }
  });

  // Drag-to-scroll on strip (vertical)
  (function() {
    var isDown = false, startY, scrollTop, dragged = false;
    strip.style.cursor = 'grab';
    strip.addEventListener('mousedown', function(e) {
      isDown = true; dragged = false;
      strip.style.cursor = 'grabbing';
      startY = e.pageY - strip.offsetTop;
      scrollTop = strip.scrollTop;
      e.preventDefault();
    });
    strip.addEventListener('mouseleave', function() { isDown = false; strip.style.cursor = 'grab'; });
    strip.addEventListener('mouseup', function(e) {
      isDown = false; strip.style.cursor = 'grab';
      if (dragged) { e.stopPropagation(); dragged = false; }
    });
    strip.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      var y = e.pageY - strip.offsetTop;
      var diff = Math.abs(y - startY + scrollTop - strip.scrollTop);
      if (diff > 5) dragged = true;
      e.preventDefault();
      strip.scrollTop = scrollTop - (y - startY) * 1.5;
    });
    strip.addEventListener('click', function(e) {
      if (dragged) { e.stopImmediatePropagation(); dragged = false; }
    }, true);
  })();

  // Mobile swipe on gallery viewer
  (function() {
    var touchStartX = 0, touchStartY = 0, swiping = false;
    galleryWrap.addEventListener('touchstart', function(e) {
      if (currentIndex < 0) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      swiping = true;
    }, { passive: true });

    galleryWrap.addEventListener('touchend', function(e) {
      if (!swiping || currentIndex < 0) return;
      swiping = false;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        if (dx < 0) goTo(currentIndex + 1);
        else goTo(currentIndex - 1);
      }
    }, { passive: true });
  })();

  // Left/right tap navigation on gallery image
  galleryImg.addEventListener('click', function(e) {
    if (currentIndex < 0) return;
    var rect = galleryImg.getBoundingClientRect();
    var clickX = e.clientX - rect.left;
    if (clickX < rect.width / 2) {
      goTo(currentIndex - 1);
    } else {
      goTo(currentIndex + 1);
    }
  });
})();
